export default __webpack_public_path__ + "static/media/star.b729ef48.svg";